<template>
  <el-form
    ref="ruleFormDom"
    style="display: initial"
    :model="filterList"
    :inline="true"
    size="mini"
    @submit.native.prevent="search"
  >
    <base-form-item
      :form-data="filterList"
      :default-label-width="defaultLabelWidth"
    >

      <template #custom="customProps">
        <slot name="custom" v-bind="customProps" />
      </template>
    </base-form-item>
    <el-form-item class="filter-item">
      <el-button
        icon="el-icon-search"
        size="mini"
        type="primary"
        @click="search"
      >查询</el-button>
    </el-form-item>

  </el-form>

</template>

<script>
import BaseFormItem from '@/components/app-form-item';
export default {
  components: {
    BaseFormItem,
  },
  props: {
    filterList: {
      type: Object,
      default: () => {
        return {};
      },
    },
    // 默认文本宽度
    defaultLabelWidth: {
      type: String,
      required: false,
      default: '80px',
    },
    // 提交请求
    submitRequest: {
      type: [Function, Promise],
      default: null,
    },
  },
  methods: {
    /** 搜索 */
    async search() {
      let is_succeed = false;

      // 表单验证
      await this.$refs.ruleFormDom.validate((valid, formRuleList) => {
        is_succeed = this.ruleFormTips(valid, formRuleList);
      });

      if (!is_succeed){
        return;
      }

      const formParams = this.paramsFormat(this.filterList);

      if (formParams !== null) {
        this.submitData(formParams);
      }

      return true;
    },
    /**
     * 重置app filter的表单数据
     */
    resetFields() {
      this.$refs.ruleFormDom.resetFields();
    },
    /**
     * 参数格式化
     * @param obj 参数配置对象
     */
    paramsFormat(obj) {
      const formParams = {};

      for (const key in obj) {
        if (obj[key]) {
          const item = obj[key];
          if (item.hidden || item.is_filter) {
            continue;
          }

          const paramsValue = item.value;
          if (
            paramsValue !== '' &&
            typeof paramsValue !== 'undefined' &&
            paramsValue !== null &&
            paramsValue[0] !== null
          ) {
            if (item.children) {
              formParams[key] = this.paramsFormat(item.children);
            } else {
              formParams[key] = item.value;
            }
          } else {
            formParams[key] = null;
          }
        }
      }

      return formParams;
    },

    /**
     * 提交数据
     * @param params 提交参数
     */
    submitData(params = {}) {
      this.isLoding = true;
      if (this.submitRequest) {
        if (this.submitRequest.then) {
          this.submitRequest(params).then(() => {
            this.isLoding = false;
            this.$refs.ruleFormDom.resetFields();
            this.$emit('search', params);
          }).catch(() => {
            this.isLoding = false;
          });
        } else {
          this.submitRequest(params);
        }
      } else {
        this.$emit('search', params);
        this.isLoding = false;
      }
    },

    /**
     * 表单验证提示
     * @param valid 是否有效
     * @param formRuleList 表单验证列表
     */
    ruleFormTips(valid, formRuleList) {
      if (valid) {
        return true;
      } else {
        for (const key in formRuleList) {
          if (formRuleList[key]) {
            const item = formRuleList[key][0];
            this.$message.warning(item.message);
            break;
          }
        }
        return false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.filter-item {
  padding: 9px 0;
  margin-right: 20px;
}
</style>
